import { addDays, differenceInCalendarDays } from 'date-fns';
import getDateKey from './getDateKey';

const getDateKeys = (timeRange: [number, number]) => {
  const diffDays = differenceInCalendarDays(timeRange[1], timeRange[0]);

  return Array.from({ length: diffDays + 1 }, (_, i) => {
    const dateKey = getDateKey(addDays(timeRange[0], i));
    return dateKey;
  });
};

export default getDateKeys;
